import script from "./StatementTableDescription.vue?vue&type=script&lang=jsx&setup=true"
export * from "./StatementTableDescription.vue?vue&type=script&lang=jsx&setup=true"

const __exports__ = script;

export default __exports__